import * as React from "react";
import type { SVGProps } from "react";
const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#0D1B27"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.87}
      strokeWidth={1.5}
      d="M10 2.5a7.5 7.5 0 0 1 7.5 7.5v0a7.5 7.5 0 0 1-7.5 7.5v0A7.5 7.5 0 0 1 2.5 10v0A7.5 7.5 0 0 1 10 2.5"
      clipRule="evenodd"
    />
    <path
      stroke="#0D1B27"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.87}
      strokeWidth={1.5}
      d="M10 10.417V6.25M10 13.333a.208.208 0 1 0 .002.417.208.208 0 0 0-.003-.417"
    />
  </svg>
);
export default SvgWarning;
